import { ResourceHelperService } from './../resource-helper.service';

/**
 * A dataservice that provides operations for journey construction rules
 */
export class JourneyConstructionRuleService {
  private singleRule: InterACT.Interfaces.IResource<InterACT.Interfaces.JourneyConstructionRules.JourneyConstructionRuleResponse>;
  private multipleRules: InterACT.Interfaces.IResource<InterACT.Interfaces.JourneyConstructionRules.JourneyConstructionRulesResponse>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.singleRule = $resource('api/journey-construction-rules/:ruleId', undefined, {
      update: { method: 'PUT' }
    });
    this.multipleRules = $resource('api/journey-construction-rules');
  }

  /**
   * Function to retrieve a set of journey construction rules
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param searchText The search text used to build up a query string in the outgoing http request
   * @returns A http promise
   */
  public getList(page: number, perPageCount: number, searchText?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, searchText);
    return this.multipleRules.get(options).$promise;
  }

  /**
   * Function to create a journey construction rule
   *
   * @param journeyConstructionRule the journey construction rule to create
   *
   * @returns A http promise object
   */
  public create(journeyConstructionRule: InterACT.Interfaces.JourneyConstructionRules.JourneyConstructionRule) {
    return this.singleRule.save(journeyConstructionRule).$promise;
  }

  /**
   * Function to update a journey construction rule
   *
   * @param journeyConstructionRule the journey construction rule to update
   * @returns A http promise object
   */
  public update(journeyConstructionRule: InterACT.Interfaces.JourneyConstructionRules.JourneyConstructionRule) {
    return (<any>this.singleRule).update({ ruleId: journeyConstructionRule.id }, journeyConstructionRule).$promise;
  }

  /**
 * Function to delete a journey construction rule
 *
 * @param journeyConstructionRuleId the id of the journey construction rule to delete
 *
 * @returns A http promise object
 */
  public delete(journeyConstructionRuleId: string) {
    return this.singleRule.delete({ ruleId: journeyConstructionRuleId }).$promise;
  }
}
